"use client";

import { worldCupPredictionPageConfig } from "@/content/world-cup-prediction";
import PredictionExperiencePage from "./prediction-experience-page";

export default function WorldCupPredictionPage() {
  return <PredictionExperiencePage config={worldCupPredictionPageConfig} />;
}
